import { useState } from "react";
import "./contactForm.css";

export default function ContactForm({ items }) {
    const [formData, setFormData] = useState({ name: "", contact: "", message: "" });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`/api/submit`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                alert("Message submitted successfully");
                setFormData({ name: "", contact: "", message: "" });
            } else {
                alert("Error submitting form");
            }
        } catch (error) {
            alert("Error submitting message");
            console.error("Error submitting form", error);
        }
    };

    return (
        <div className="contact-form-container">
            <h2 className="contact-form-title">{items.title}</h2>
            <p className="contact-form-cta-sub">
                {items.ctaSub}
            </p>
            <a
                className="contact-form-cta-link"
                href="mailto:laura.rodriguez@protargetgroupllc.com"
            >
                {items.contactBtn}
            </a>
        </div>
    );
}
